import type { CurriculumTierId, TierCheckpoint } from '../types';
import { LEVEL_6_KEYS, LEVEL_6_VALID } from './curriculum/grundniveau';
import { NIVEAU_1_SPRINT_WORDS, NIVEAU_1_UNLOCKED_KEYS } from './curriculum/niveau-1';
import { NIVEAU_2_SPRINT_WORDS, NIVEAU_2_UNLOCKED_KEYS } from './curriculum/niveau-2';
import { NIVEAU_3_SPRINT_WORDS, NIVEAU_3_UNLOCKED_KEYS } from './curriculum/niveau-3';
import {
  NIVEAU_4_ALPHABET_WORDS,
  NIVEAU_4_UNLOCKED_KEYS,
} from './curriculum/niveau-4';
import {
  NIVEAU_5_SPRINT_WORDS,
  NIVEAU_5_UNLOCKED_KEYS,
} from './curriculum/niveau-5';
import {
  NIVEAU_6_SPRINT_WORDS,
  NIVEAU_6_UNLOCKED_KEYS,
} from './curriculum/niveau-6';

const GN_KEYS = [...LEVEL_6_KEYS, ' '];

export const CHECKPOINTS: TierCheckpoint[] = [
  {
    id: 'checkpoint-after-grundniveau',
    afterTierId: 'grundniveau',
    beforeTierId: 'niveau-1',
    title: 'Hurtig test',
    description:
      'Skriv så mange ord du kan på 1 minut — med det du har lært på grundniveau.',
    goal: 'Slå din egen rekord med ord fra hjemmerækken.',
    unlockedKeys: GN_KEYS,
    sprintWords: LEVEL_6_VALID,
    sprintDurationMs: 60_000,
  },
  {
    id: 'checkpoint-after-niveau-1',
    afterTierId: 'niveau-1',
    beforeTierId: 'niveau-2',
    title: 'Hurtig test',
    description:
      'Skriv så mange ord du kan på 1 minut — med tasterne fra Niveau 1.',
    goal: 'Slå din egen rekord med det du har lært indtil nu.',
    unlockedKeys: NIVEAU_1_UNLOCKED_KEYS,
    sprintWords: NIVEAU_1_SPRINT_WORDS,
    sprintDurationMs: 60_000,
  },
  {
    id: 'checkpoint-after-niveau-2',
    afterTierId: 'niveau-2',
    beforeTierId: 'niveau-3',
    title: 'Hurtig test',
    description:
      'Skriv så mange ord du kan på 1 minut — med tasterne fra Niveau 1 og 2.',
    goal: 'Slå din egen rekord med det du har lært indtil nu.',
    unlockedKeys: NIVEAU_2_UNLOCKED_KEYS,
    sprintWords: NIVEAU_2_SPRINT_WORDS,
    sprintDurationMs: 60_000,
  },
  {
    id: 'checkpoint-after-niveau-3',
    afterTierId: 'niveau-3',
    beforeTierId: 'niveau-4',
    title: 'Hurtig test',
    description:
      'Skriv så mange ord du kan på 1 minut — med tasterne fra Niveau 1–3.',
    goal: 'Slå din egen rekord med det du har lært indtil nu.',
    unlockedKeys: NIVEAU_3_UNLOCKED_KEYS,
    sprintWords: NIVEAU_3_SPRINT_WORDS,
    sprintDurationMs: 60_000,
  },
  {
    id: 'checkpoint-after-niveau-4',
    afterTierId: 'niveau-4',
    beforeTierId: 'niveau-5',
    title: 'Hurtig test',
    description:
      'Skriv så mange ord du kan på 1 minut — med hele alfabetet.',
    goal: 'Slå din egen rekord med ord fra hele tastaturet.',
    unlockedKeys: NIVEAU_4_UNLOCKED_KEYS,
    sprintWords: NIVEAU_4_ALPHABET_WORDS,
    sprintDurationMs: 60_000,
  },
  {
    id: 'checkpoint-after-niveau-5',
    afterTierId: 'niveau-5',
    beforeTierId: 'niveau-6',
    title: 'Hurtig test',
    description:
      'Skriv så mange ord du kan på 1 minut — med store bogstaver og tegn.',
    goal: 'Slå din egen rekord med det du har lært i Niveau 5.',
    unlockedKeys: NIVEAU_5_UNLOCKED_KEYS,
    sprintWords: NIVEAU_5_SPRINT_WORDS,
    sprintDurationMs: 60_000,
  },
  {
    id: 'checkpoint-after-niveau-6',
    afterTierId: 'niveau-6',
    beforeTierId: 'niveau-6',
    title: 'Hurtig test',
    description:
      'Skriv så mange ord du kan på 1 minut — fuld blindskrift.',
    goal: 'Slå din egen rekord — du har lært hele pensum.',
    unlockedKeys: NIVEAU_6_UNLOCKED_KEYS,
    sprintWords: NIVEAU_6_SPRINT_WORDS,
    sprintDurationMs: 60_000,
  },
];

const CHECKPOINT_MAP = new Map(CHECKPOINTS.map((c) => [c.id, c]));

export function getCheckpoint(id: string): TierCheckpoint | undefined {
  return CHECKPOINT_MAP.get(id);
}

export function getCheckpointAfterTier(
  tierId: CurriculumTierId,
): TierCheckpoint | undefined {
  return CHECKPOINTS.find((c) => c.afterTierId === tierId);
}
